
(function currencyModuleDefinition() {

    'use strict';

    angular.module('Currency', []);

})();